module.exports = __webpack_public_path__ + "44bb7d4d3683e613d4155c80482f9a84.MP3";